module.exports = __webpack_public_path__ + "static/media/aboutGif.c9089817.gif";